import { type RegistrationDataDto } from '@api'

import { specifiableReferralOptions } from './consts'
import type {
  QuestionnaireFormValues,
  SpecifiableReferralOptions,
} from './types'

export const isSpecifiableReferralOption = (
  option: string,
): option is SpecifiableReferralOptions =>
  specifiableReferralOptions.some((referralOption) => referralOption === option)

export const transformQuestionnaireFormToRequestOptions = (
  values: QuestionnaireFormValues,
): RegistrationDataDto => {
  const communicationValue = values[values.preferredCommunication]

  const referralOption = isSpecifiableReferralOption(values.referral)
    ? values[values.referral]
    : values.referral

  if (!communicationValue) {
    throw new Error('Preferred communication is required')
  }

  if (!referralOption) {
    throw new Error('Referral is required')
  }

  return {
    position: values.businessType,
    communicationMethod: values.preferredCommunication,
    communicationValue,
    knowAboutUsFrom: referralOption,
    email: values.Email || undefined,
  }
}
